<template>
  <div class="index">
    <div class="choose-item" @click="goPage('/social/serve/child?id='+item.id+'&title='+item.title)" v-for="(item, index) in list">
      <img :src="item.image" alt="">
      <div>{{item.title}}</div>
    </div>
	<Footer></Footer>
  </div>
</template>

<script>
import {getSocietyCategory} from "@api/public";
import Footer from "@components/NewFooter";
export default {
  name: "CateList",
  components: {
	  Footer
  },
  props: {},
  data: function () {
    return {
  	  list:[],
    };
  },
  watch: {

  },
  mounted: function () {
	  this.getList();
  },
  methods: {
	getList(){
		getSocietyCategory().then(res => {
		  this.list=res.data
		});
	},
    goPage(url) {
      console.log(url)
      this.$router.push({ path: url });
    }
  },
};
</script>
<style lang="scss" scoped>
.index {
  min-height: 100vh;
  background-color: #fceeef;
}

.choose-item{
  display: flex;
  align-items: center;
  background-color: #fff;
  border-radius: .2rem;
  padding: .3rem;
  margin-top: .4rem;
  margin: .4rem .4rem 0;
  img{
    width: 1rem;
    height: 1rem;
    margin-right: .3rem;
  }
}
</style>
